'use strict';

import UserProfile from './components/UserProfile.vue';

export default class {

    constructor() {
        // Register component globaly
        Vue.component('user-profile', UserProfile);

    }
}